<script setup lang="ts">
import { languageOptions, t } from '@/utils/i18n';

const settingsStore = useSettingsStore();
</script>

<template>
  <USelect
    v-model="settingsStore.language"
    :items="languageOptions"
    :aria-label="t('Language')"
    icon="mdi:translate"
    size="sm"
    class="min-w-32"
  />
</template>
